import { myAxios } from "./helper";
import { toast } from "react-toastify";

export const getAllEmployees = async (token) => {
    try {
        const response = await myAxios.get("/admin/employees", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        toast.error("Failed to fetch employees");
        throw error;
    }
};

export const getEmployeeById = async (id, token) => {
    try {
        const response = await myAxios.get(`/admin/employees/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        toast.error("Failed to fetch employee");
        throw error;
    }
};

export const createEmployee = async (employeeData, token) => {
    try {
        const response = await myAxios.post("/admin/create-employee", employeeData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        toast.success("Employee created successfully");
        return response.data;
    } catch (error) {
        toast.error("Failed to create employee");
        throw error;
    }
};

export const updateEmployee = async (id, updatedData, token) => {
    try {
        const response = await myAxios.put(`/admin/employees/${id}`, updatedData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        toast.success("Employee updated successfully");
        return response.data;
    } catch (error) {
        toast.error("Failed to update employee");
        throw error;
    }
};

export const deleteEmployee = async (id, token) => {
    try {
        const response = await myAxios.delete(`/admin/employees/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        toast.success("Employee deleted successfully");
        return response.data;
    } catch (error) {
        toast.error("Failed to delete employee");
        throw error;
    }
};
export const assignTicketToEmployee = async (ticketId, employeeId, token) => {
  const params = new URLSearchParams();
  params.append("ticketId", ticketId);
  params.append("employeeId", employeeId);

  const response = await myAxios.post(`/api/contact/assign-ticket`, params, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

